import {useCallback, useEffect, useState} from 'react';
import {useAuth} from '../../../helpers/AuthContext';

export default function useSellerOrders() {
  const {fetch: authFetch, API_URL} = useAuth();
  const [orders, setOrders] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadOrders = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const response = await authFetch(`${API_URL}/v1/seller/orders`);
      const body = await response.json();
      if (!response.ok) {
        throw new Error(body.message || body.error || 'Failed to load orders');
      }

      setOrders(body.data || []);
      setMeta(body.meta || {});
    } catch (loadError) {
      setError(loadError.message || 'Failed to load orders');
    } finally {
      setLoading(false);
    }
  }, [API_URL, authFetch]);

  useEffect(() => {
    loadOrders();
  }, [loadOrders]);

  return {
    orders,
    meta,
    loading,
    error,
    reload: loadOrders,
  };
}
